module.exports = __webpack_public_path__ + "img/bubbles-desktop.4519f268.svg";